import React, { useEffect, useRef } from "react";
import { Form, Spin, Modal, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";

const { TextArea } = Input;
const PestDiseaseAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const dispatch = useDispatch();

  const onFinish = async (data) => {
    data.pdId = prodd?.pdId ? prodd?.pdId : null;
    const res = await dispatch(
      save({
        ...data,
        url: "pest_disease/save_pestdisease",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <Modal
      title={`${prodd?.pdId ? "Update Pest" : "Add Pest"}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[49.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <Form.Item
          name="pdPest"
          label={"Name"}
          rules={[
            {
              required: true,
              message: "Please add name",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>
        <Form.Item name="pdDesc" label={"Description"}>
          <TextArea rows={3} className="text_area" />
        </Form.Item>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : prodd?.pdId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default PestDiseaseAdd;
